/* eslint-disable no-shadow */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { navigate } from '@reach/router';
import { urlSafe } from '@/utils';
import { RootState } from '@/redux/reducers';
import { logoutUserActions } from '@/redux/actions';
import { LogoutOutlined } from '@/icons';
import Dropdown from '@/components/Dropdown';
import iconUserGray from '@/assets/icons/user.svg';
import './styles.less';
import env from '@/env';

interface AccountProps {
  textColor?: string;
  iconUser?: string;
}

enum AuthDropdownValue {
  logout = 'logout',
  dashboard = 'dashboard',
}

const Account: React.FC<AccountProps> = ({ textColor, iconUser }) => {
  const dispatch = useDispatch();
  const authUser = useSelector((state: RootState) => state.authUser.data);
  const { userInfo } = useSelector((state: RootState) => state.membership);
  const { organisation } = useSelector((state: RootState) => state.openBankingDiretory);

  const userDropdownOptions = [
    {
      label: (
        <>
          <LogoutOutlined />
          <span style={{ marginLeft: 8 }}>Logout</span>
        </>
      ),
      value: 'logout',
    },
  ];

  const handleChangeDropdownUser = (value: string) => {
    switch (value) {
      case AuthDropdownValue.logout:
        dispatch(logoutUserActions.request());
        break;
      case AuthDropdownValue.dashboard:
        organisation?.subdomain
          ? navigate(`https://${organisation.subdomain}.${env.domain}/dashboard/my-organisation`)
          : navigate(`https://www.${env.domain}/dashboard/my-directory`);
        break;
      default:
        break;
    }
  };

  const switchOrganisation = (organisationName: string) => {
    window.location.href = `https://${urlSafe(organisationName)}.${env.domain}`;
  };

  // Put the logout to the end of array
  if (userInfo?.memberships?.length > 1) {
    userInfo.memberships.forEach((org) => {
      const orgArr = {
        label: (
          <button
            className="Account-organisation"
            onClick={() => switchOrganisation(org.organisationName)}
          >
            <span>{org.organisationName || 'Unknown'}</span>
          </button>
        ),
        value: org.organisationId,
      };
      userDropdownOptions.splice(1, 0, orgArr);
    });
  }
  const optionsDropdown = userDropdownOptions;

  return (
    <div className="Account">
      <Dropdown
        options={optionsDropdown}
        placeholder={
          <>
            <img src={iconUser || iconUserGray} alt="User" />
            <span style={{ color: textColor }}>Welcome {authUser?.firstName}</span>
          </>
        }
        onChange={(e: { value: string }) => handleChangeDropdownUser(e.value)}
        className="PublisherHeader-user"
      />
    </div>
  );
};

export default Account;
